import React from "react";
import styled from "@emotion/styled";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PendingIcon from '@mui/icons-material/Pending';
import { useTheme } from "@mui/styles";
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

const LeadPathConnectors = ({milestone, mapIndex, timeline}) => {
  const theme = useTheme()

  return (
    <>
      {(milestone.milestone === 'Public Records Updated' && milestone.activeDiscrepancies === 0) || milestone.milestone === 'All Discrepancies Resolved' ?
        <TimelinePath>
          {mapIndex !== 0 ?
            <TimelineConnector className='small' style={{height: milestone.notify ? '0.9rem' : '0.5rem'}} />
          :
            <></>
          }
          <TaskAltIcon style={{color: milestone.notify ? `${theme.palette.primary.main}` : '', margin: mapIndex !== 0 ? '0' : '0.5rem 0 0 0'}} />
          <TimelineConnector />
        </TimelinePath>
      : milestone.milestone === 'Discrepancies Detected' || (milestone.milestone.includes('Manual') && milestone.milestone.includes('Investigation')) || milestone.milestone === 'Internal Records Updated' || milestone.milestone === 'Manual Renegotiation Investigation Opened' ?
        <TimelinePath>
          {mapIndex !== 0 &&
            <TimelineConnector className='small' style={{height: milestone.notify ? '0.9rem' : '0.5rem'}} />
          }
          <div style={{margin: mapIndex !== 0 ? '0 0 0 0' : '0.5rem 0 0 0'}}>
            {milestone.milestone === 'Internal Records Updated' ?
              <PendingIcon style={{color: milestone.notify ? `${theme.palette.primary.main}` : ''}} />
            :
              <FlagCircleIcon style={{color: milestone.notify ? `${theme.palette.primary.main}` : ''}} />
            }
          </div>
        </TimelinePath>
      : milestone.milestone.includes('Finalized') || milestone.milestone === 'Lead Dismissed' ?
        <TimelinePath>
          {mapIndex !== 0 ?
            <TimelineConnector className='small' style={{height: milestone.notify ? '0.9rem' : '0.5rem'}} />
          :
            <></>
          }
          {milestone.awaitingUpdate || mapIndex !== 0 ?
            <RadioButtonCheckedIcon style={{color: milestone.notify ? `${theme.palette.primary.main}` : '', marginTop: (mapIndex === 0 && milestone.notify) ? '0.7rem' : mapIndex === 0 ? '0.5rem' : ''}} />
          :
            <SportsScoreIcon style={{color: milestone.notify ? `${theme.palette.primary.main}` : '', marginTop: (mapIndex === 0 && milestone.notify) ? '0.7rem' : mapIndex === 0 ? '0.5rem' : ''}} />
          }
          <TimelineConnector />
        </TimelinePath>
      : milestone.milestone === 'Public Records Verified' ?
        <TimelinePath>
          <SportsScoreIcon style={{color: milestone.notify ? `${theme.palette.primary.main}` : '', margin: '0.5rem 0 0 0'}} />
          <TimelineConnector />
        </TimelinePath>
      :
        <TimelinePath>
          {mapIndex !== 0 ?
            <TimelineConnector className='small' style={{height: milestone.notify ? '0.9rem' : '0.5rem'}} />
          :
            <></>
          }
          <RadioButtonCheckedIcon style={{color: milestone.notify ? `${theme.palette.primary.main}` : '', marginTop: (mapIndex === 0 && milestone.notify) ? '0.7rem' : mapIndex === 0 ? '0.5rem' : ''}} />
          <TimelineConnector />
        </TimelinePath>
      }
    </>
  )
}

const TimelinePath = styled.div(({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 2.2rem;
  min-width: 2.2rem;
  height: 100%;
  padding: 0;
  background: ${theme.palette.common.cardBackground};
  color: ${theme.palette.common.grayText};

  > svg:first-child,
  > div:first-child:not(.small) {
    margin: 0.3rem 0 0 !important;
  }

  svg {
    width: 1.8rem;
    height: 1.8rem;
    color: ${theme.palette.common.grayText};
  }
`)

const TimelineConnector = styled.div(({ theme }) => `
  width: 0.1rem;
  height: 100%;
  min-height: 1.4rem;
  background: ${theme.palette.common.grayBorder};
  margin-top: 0.3rem;

  &.small {
    height: 0.25rem !important;
    min-height: 0.25rem;
  }
`)

export default LeadPathConnectors
